app.service('appealsService', function ($http) {

  // Routes | Certified Values |-----------------------------------------
  this.updateCertifiedValue = function (obj) {
    return $http.post(`/appeals/updateCertifiedValue`, obj)
      .then(function (response) {
        return response
      })
  }  
  this.getAppealsByCounty = function (obj) {
    return $http.post(`/appeals/getAppealsByCounty`, obj)
      .then(function (response) {
        return response
      })
  }  
  // ------------------------------------------------------------------
  
  // Routes | Appeal Batches |-----------------------------------------
  this.updateAppealBatchStatus = function (obj) {
    return $http.post(`/appeals/updateAppealBatchStatus`, obj)
      .then(function (response) {
        return response
      })
  }
  this.getPropertiesToProtest = function (obj) {
    return $http.post(`/appeals/getPropertiesToProtest`, obj)
      .then(function (response) {
        return response
      })
  }
  this.loadAppealsByBatchID = function (obj) {
    return $http.post(`/appeals/loadAppealsByBatchID`, obj)
      .then(function (response) {
        return response
      })
  }
  this.createAppealBatches = function (obj) {
    return $http.post(`/appeals/createAppealBatches`, obj)
      .then(function (response) {
        return response
      })
  }
  this.getAppealsByFilter = function (obj) {
    return $http.post(`/appeals/getAppealsByFilter`, obj)
      .then(function (response) {
        return response
      })
  }
  this.getAppealBatches = function (obj) {
    return $http.post(`/appeals/getAppealBatches`, obj)
      .then(function (response) {
        return response
      })
  }
  //-------------------------------------------------

})